import React from 'react';
import { Alert } from '@ublend-npm/aulaui-next';
import { AlertText } from './IntegrationDisabledAlert.styled';

export interface IntegrationDisabledAlertProps {
  className?: string;
}

export const IntegrationDisabledAlert = ({
  className,
}: IntegrationDisabledAlertProps) => (
  <Alert type="error" className={className}>
    <AlertText>
      This integration has been disabled by your institution.
    </AlertText>
  </Alert>
);
